import styled from 'styled-components';

export default styled.div`
  height: calc(5em + 27px);
`;
